"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (url) {
  var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    "properties": {
      "group": "document",
      "type": "source",
      "pdf": {
        "status": "FINISHED",
        "url": url,
        "errorLocation": "https://errorLocation.com",
        "errorCode": 0,
        "version": "1"
      },
      "enabled": true
    }, "actionTime": 1581519580552
  };
};